module.exports = __webpack_public_path__ + "img/平台2.aca4e756.png";